export default {
    // СУНДУКИ
    chest_gray_1: {
        grade: 1, type: 'chest', src: `/../images/ver2/scores/chest/chest_gray_1.png`,
        title: 'Серый сундук сокровищ',
        discription: 'Небольшой базовый сундук сокровищ',
    },
    chest_gray_2: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_gray_2.png`,
        title: 'Серый сундук сокровищ',
        discription: 'Небольшой продвинутый сундук сокровищ',
    },
    africa_white: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/africa_white.png`,
        title: 'Африка: белый сундук',
        discription: 'Сундук, из которго выпадают сувениры всех наборов',
    },
    chest_africa_white: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_africa_white.png`,
        title: 'Африка: белый сундук',
        discription: 'Сундук, из которго выпадают сувениры всех наборов',
    },
    chest_africa_red: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_africa_red.png`,
        title: 'Африка: красный сундук',
        discription: 'Сундук, из которго выпадают сувениры красного набора',
    },
    chest_africa_black: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_africa_black.png`,
        title: 'Африка: черный сундук',
        discription: 'Сундук, из которго выпадают сувениры черного набора',
    },
}